import { StickyMenuItem } from './styled';
export function MenuSingleSelectItem(props) {
    const { selected = false, onClick, children } = props;
    return (<StickyMenuItem $sticky={selected} selected={selected} onClick={onClick}>
      {children}
    </StickyMenuItem>);
}
